var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 195 195",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m97.5 21.5c-33.3 0-60.3 27-60.3 60.3 0 8.6 1.8 16.7 5 24.1.1.3.3.6.4.9.3.7.7 1.5 1.1 2.2.2.3.3.6.5 1 .4.8.9 1.7 1.4 2.5.1.1.1.2.2.4 2.5 4.2 5.6 8.1 9 11.5l35.7 45.8c3.5 4.5 10.3 4.5 13.8 0l35.7-45.7c3.5-3.5 6.5-7.4 9.1-11.6 5.5-9.1 8.6-19.7 8.6-31 .1-33.4-26.9-60.4-60.2-60.4zm33.2 61.9c-2.4 5.6-6.3 10.2-11 14-4.5 3.7-9.2 7.2-13.8 10.8-2.6 2-5.1 4.1-7.6 6.2-.6.5-.9.5-1.5 0-6-4.8-12-9.7-18.1-14.4-3.7-2.8-7.2-5.8-10-9.5-2.9-3.7-5.1-7.7-5.8-12.3-1.2-7.7 1.4-14 7.6-18.5 6.2-4.6 13-4.9 19.9-1.6 2.1 1 3.7 2.6 5.2 4.3.7.7 1.3 1.5 2 2.3.9-1 1.7-1.9 2.6-2.9 5.8-6.7 16.6-7.7 24.1-2.5 7.7 5.5 10.3 15.1 6.4 24.1z",
    fill: "#ffffff",
    "data-original": "#d50000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.146d1b3998aa9b0ef9ae842f41712e9a.svg";
export { ForwardRef as ReactComponent };